<template style="">
	<div class='content' >
		<van-nav-bar
		   title="二维码"
		   left-text=""
		   right-text=""
		   left-arrow
		   @click-left="onClickLeft"
		  @click-right="onClickRight"
		/>
		<van-row  span="24" class=""  type="flex" justify="center">
				<van-col  span="22" offset="2">
				<div class="finishedOrderNumber">
					票号凭证号：<span id="orderID">{{orderID}}</span>
				  
			        <p v-if="hide"> {{ticketTypeID}}</span></p>
					<p>提示：刷码时将手机亮度调高，悬浮扫描平台3-5CM的位置时识别最佳</p>
					
				</div>
			 </van-col>
		</van-row>
		<van-cell-group class='qrlist' style="padding-top: 20px; padding-bottom: 20px;">
			<van-row  span="24" class=""  type="flex" justify="center">
			  	<van-col  span="12" style="width: 160px;">
			  		<div id="qrCode" ref="qrCodeUrl"></div>
		   		 </van-col>
		    </van-row>
		 </van-cell-group>	
		 <van-row  span="24" class=""  type="flex" justify="center">
		 	<van-col  span="22" offset="2">
			  <span style="font-size: 12px;">码内信息：(门票状态全部为已验票,已退票,已过期，二维码无法使用)</span>	
		   </van-col>
		 	 <van-col  span="22" offset="2">
		 	 <p v-if="hide_"> 
		 	 	剩余时长：<span id="">{{remainValidTime}}分钟</span>
		 	 	已用时长：<span id="">{{withholdTime}}分钟</span>
		 	 	
		 	 </p>
		 	 <p v-if="hide_a" style="color: red;" @click="btn()"> 
		 	 	
		 	 	 <van-col span="20" style="font-size: 16px; height:35px ;line-height:35px; ">需补金额：
		 	 	 	{{priceDifferentAmount}}元  请补差价</van-col>
	  		  	
	  		  	
	  		  	   <van-col span="2" style="padding-top:8px;">
	  		  	   	
					  <van-icon name="arrow"  size="18" color="#1989fa"/> 
					</van-col>	
		 	 </p>
		 	
		 	 </van-col>
			
		    <van-checkbox-group >
	            <div class="van-checkbox-cell-group" v-for="(item,index) in list" :key="index" style="margin-bottom: 20px;margin-top: 15px;">
	                <van-col  span="22" offset="2"  >
					   <van-col span="2" style="margin-top:3px;" >
  	  		  		 		<van-icon name="card" color="#4fc08d" />
  	  		  		 	</van-col>
  	  		  		 	 <van-col v-if="hide">{{item.subTicketID}}</van-col>	
  	  		  		 	<van-col span="18" style="font-size: 13px;">{{item.ticket}}</van-col>
  		  		  		<van-col span="4">￥{{item.price}}</van-col>
  		  		    </van-col>
  		  		    <van-col span="22" offset="2"  >
  		  		   	 	<van-col span="2" style="margin-top:8px;" >
  	  		  		 		<van-icon name="coupon" color="#4fc08d" />
  	  		  		 	</van-col>
					   <van-col span="18" style="margin-top: 6px; font-size: 13px;"> {{item.ticketTypeName}}</van-col>
					   <van-col span="4" style="margin-top: 6px; font-size: 13px;"> {{item.code}}</van-col>
				    </van-col>
				    <van-col span="22" offset="2"  >
				    	<van-col span="2" style="margin-top:8px;" >
  	  		  		 		<van-icon name="clock-o" color="#4fc08d" />
  	  		  		 	</van-col>
					   <van-col span="20" style="margin-top: 6px; font-size: 13px;"> 开始时间：{{item.time}}</van-col>
					 
					   <van-col span="20" style="margin-top: 6px; font-size: 13px;"> 结束时间：{{item.time1}}</van-col>
			        </van-col>
			          <van-col span="22" offset="2" >
				    	<van-col span="2" style="margin-top:8px;" >
  	  		  		 		<van-icon name="qr" color="#4fc08d" />
  	  		  		 	</van-col>
					   <van-col span="18" style="margin-top: 6px;color: #00BFFF; font-size: 13px;"  @click="ticketcs(index)" >查看门票对应过闸次数</van-col>
					 	<van-col span="2" style="padding-top:8px;">
						  <van-icon name="arrow"  size="18" color="#1989fa"/> 
						</van-col>	
			        </van-col>
				</div>
	        </van-checkbox-group>
		</van-row>
		
	    <van-tabbar v-model="active">
			    <van-tabbar-item icon="home-o" @click="home()">购票首页</van-tabbar-item>
				<van-tabbar-item icon="setting-o"  @click="user()">个人中心</van-tabbar-item>
		</van-tabbar>
		
	</div>
</template>

<script>
  import QRCode from 'qrcodejs2'
  export default {
  data () {
    return {
    	 hide_a:false,
    	 hide_:false,
    	 hide:false,
    	 active:1,
    	 order:'',
    	 orderID:"",
    	 qr:'',
    	 code:"",
    	 subTicketID:'',
    	 subTicketID_:'',
    	 ticketTypeID:'',
    	 remainValidTime:'',
    	 withholdTime:'',
    	 priceDifferentAmount:'',
    	 list:[],
    	 }
    },
    mounted(){
    	//this.time();
    	
    	this.ticketlist()
    },
    beforeDestroy(){
	  clearInterval(this.timer);　　// 清除定时器
	  this.timer = null;
	},
	methods: {
		
		ticketcs(index){
			 let subTicketID = this.list[index].subTicketID;
			 this.$router.push({ path: "/mn_ticketTicket",query: { subTicketID: subTicketID }});
		},
		 creatQrCode(){
		 	this.orderID= this.qr;
		 	let order = this.qr;
		    document.getElementById("qrCode").innerHTML = "";
		 	new QRCode(this.$refs.qrCodeUrl, {
		 	text: order,
		 	width: 150,
		 	height: 150,
		 	colorDark: '#000000', 
		 	colorLight: '#ffffff', 
		 	correctLevel:QRCode.CorrectLevel.H 
		 	})
		 },
		  creatQrCode_(){
		 	this.orderID=this.$route.query.order;
		 	let order =this.$route.query.order;
		    document.getElementById("qrCode").innerHTML = "";
		 	new QRCode(this.$refs.qrCodeUrl, {
		 	text: order,
		 	width: 150,
		 	height: 150,
		 	colorDark: '#000000', 
		 	colorLight: '#ffffff', 
		 	correctLevel:QRCode.CorrectLevel.H 
		 	}) 
		 },
		settime(){
			this.timer= setInterval(() => {
		        this.Timeprice();
		      }, 5000);
		},
	
		btn(){
			 let storage=window.sessionStorage;
			 var openid = storage.getItem("openid")
			let total=this.priceDifferentAmount;
			let payWay='10';
		 	 this.$axios({
		            url: "/api/sell/wxSubmitOrder",
		            method: "post",
		            data: {
		            	
		            	payWay:payWay,
		                openid:openid,
						orderAmount: total
		            },
		            headers: {
		              "Content-Type": "application/json; charset=utf-8"
		            }
			    })
				.then(res => {
					let datalist =res.data;
					let data =res.data.JSAPI_result;
					if (datalist.result_msg == '失败') {
						alert("支付失败，请重新进入系统购票");
					} else {
						if (typeof WeixinJSBridge == "undefined") {
							if (document.addEventListener) {
								document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(data.appid, data.timeStamp, data.nonceStr, data.prepayID, data.paySign, data.orderID), false);
							} else if (document.attachEvent) {
								document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady(data.appid, data.timeStamp, data.nonceStr, data.prepayID, data.paySign, data.orderID));
								document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady(data.appid, data.timeStamp, data.nonceStr, data.prepayID, data.paySign, data.orderID));
							}
						} else {
							
							 this.onBridgeReady(data.appid, data.timeStamp, data.nonceStr, data.prepayID, data.paySign, data.orderID);
						}
					}
				})
	            .catch(err => {
	              console.log(err);
	              this.$notify({ type: 'warning', message: '调取支付失败' });
		     
	        });
	       
		 },
		onBridgeReady(appid, timeStamp, nonceStr, prepay_id, paySign, orderID) {
			   let payWay='10';
	    	    let thta =this;
	    	    let flag ="2";
	    	    let storage=window.sessionStorage;
				var openid = storage.getItem("openid")
  			    var ticketID =this.orderID;
  			    var orderAmount=this.priceDifferentAmount;
			    var discountAmount ="";
	      	   WeixinJSBridge.invoke(
			      'getBrandWCPayRequest', {
			        	"appId": appid,   
						"timeStamp": timeStamp,  
						"nonceStr": nonceStr, 
						"package": "prepay_id=" + prepay_id + "",
						"signType": "MD5",        
						"paySign": paySign 
			      },
			      function(res){
			           var temp =res.err_msg;
     				  if(temp.indexOf('ok')>-1){
			        	 thta.$axios({
				            url: "/api/sell/priceDifferentConfirmOrder",
				            method: "post",
				            data: {
				             payWay:payWay,
				             flag:flag,
				             openid:openid,
				             orderAmount:orderAmount,
				             ticketID:ticketID,
				             discountAmount:discountAmount,
				             orderID:orderID ,
				            },
				            headers: {
				              "Content-Type": "application/json; charset=utf-8"
				            }
				          })
				            .then(res => {
				               if(res.data.orderID !== "" ) {
				              /*  this.$message({
				                  showClose: true,
				                  message: "success,支付成功",
				                  type: "success",
				                  duration: 5000
				                });*/
				                //alert("支付成功");
				                //window.location.href = '/wx_ticketOrderlist';
				               thta.$router.push({ path: "/mn_ticketOrderQR"});
				              } else {
				               /* this.$message({
				                  showClose: true,
				                  message: res.data.errMsg,
				                  type: "error",
				                  duration: 5000
				                });*/
				                 alert("支付失败");
				              }
				            })
				            .catch(err => {
				              console.log(err);
				              alert("支付失败");
				            });
			     		 // 使用以上方式判断前端返回,微信团队郑重提示：
			            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
			     } 
			   }); 
			},	
			
		Timeprice(){
			let ticketID = this.orderID;
			let ticketTypeID  = this.ticketTypeID ;
				this.$axios({
						url: "/api/ticket/getPriceDifferentData",
						method: "get",
						params: {
							ticketTypeID: ticketTypeID,
							ticketID:ticketID,
						}
					})
					.then(res => {
						
						let data =res.data.data;
						console.log(data)
						this.hide_=true;
						this.priceDifferentAmount=data.priceDifferentAmount;
						this.remainValidTime=data.remainValidTime;
						this.withholdTime=data.withholdTime;
						if(data.priceDifferentAmount>0){
							this.hide_a=true;
						}
						
					})
				.catch(err => {
					console.log(err);
				});
		},
		ticketlist(){
		 	let orderID= this.$route.query.order;
			this.orderID_=orderID;
			this.$axios({
					url: "/api/order/query",
					method: "get",
					params: {
						orderID: orderID,
					}
				})
			 .then(res => {
			 	var data = res.data;
				this.list=[];
				let length=res.data.length;
				console.log(data)
				let ticket_='';
				let subTicketID_='';
				let ticketFeeMethod = res.data[0].ticketFeeMethod;
			
				if(ticketFeeMethod==1){
					ticket_=res.data[0].ticketID;
				    subTicketID_=res.data[0].subTicketID;
					this.ticketTypeID=res.data[0].ticketTypeID;
				}
				for (const i in data) {
					   if(data[i].ticketStatus == 0) {
								var ticketStatus = "已入库";
							}
							if(data[i].ticketStatus == 1) {
								var ticketStatus = "已出库";
								
							}
							if(data[i].ticketStatus == 2) {
								var ticketStatus = "未验票"
							
							}
							if(data[i].ticketStatus == 3) {
								var ticketStatus = "已验票";
								
							}
							if(data[i].ticketStatus == 4) {
								var ticketStatus = "已退票";
								
							}
							if(data[i].ticketStatus == 5) {
								var ticketStatus = "已作废";
							
							}
							if(data[i].ticketStatus == 6) {
								var ticketStatus = "已禁用";
								
							}
							if(data[i].ticketStatus == 7) {
								var ticketStatus = "已挂失";
								
							}
							if(data[i].ticketStatus == 8) {
								var ticketStatus = "已过期";
								
							}
							this.list.push({
								ticket: data[i].ticketID,
							    code: ticketStatus,
								ticketTypeName: data[i].ticketTypeName,
								price: data[i].ticketPrice,
								time:data[i].ticketStart,
								time1:data[i].ticketEnd,
								subTicketID:data[i].subTicketID,
							});
						}
				    if(length==1){
				    	 if(ticketFeeMethod==1){
				    	 	 this.qr=ticket_;
				    	 	 this.subTicketID=subTicketID_;
				    	 	
				  			 this.$nextTick(function () {
					            this.creatQrCode();
					            this.Timeprice();
					            this.settime();
					        })	
				  				
						  }
				    	 
				    }else{
				    	 this.$nextTick(function () {
					        this.creatQrCode_();
					      })
				    }
				
				       
				
				
			 })
				.catch(err => {
				console.log(err);
			});
		
		
		
		 },
		 
		 home(){
	    	 this.$router.push({ path: "/mn_ticketIndex" });
	    },
	    user(){
	    	 this.$router.push({ path: "/mn_ticketUser" });
	    },
		onLoad(){
	        this.loading = false;
			this.finished = true;
	       
	    },
	    onClickLeft(){
	    	this.$router.go(-1);//返回上一层
			//this.$router.push({ path: "/wx_ticketUser",query: { total: total , numlist: numlist }  });
		},
		onClickRight(){
			
		},
			// 选项格式化函数
		onSubmit(){
		 	
		 },
        time(){
		      this.timeDate=this.dateFormat();
		      this.total = this.$route.query.total;
		      this.numlist= this.$route.query.numlist;
		     
		    },
		onConfirm(date) {
		 	  this.timeDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
		      this.showCalendar = false;
		    },    
		dateFormat() {//获取当前时间
		        var date=new Date();
		        var year=date.getFullYear();
		        var month= date.getMonth()+1<10 ? +(date.getMonth()+1) : date.getMonth()+1;
		        var day=date.getDate()<10 ? +date.getDate() : date.getDate();
		        //var hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
		        //var minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
		        //var seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
		        return year+"-"+month+"-"+day
            },   
      
		 
	}
}
</script>

<style scoped>
     
	
</style>


// WEBPACK FOOTER //
// src/system/index/wechatlistmini/mn_ticketOrderQR.vue